import React, { lazy, Suspense } from 'react';
import { getQueryParamByName } from '../../common/utilities/queryParameters';

const MapsScreen = lazy(() => import('./mapsScreen'));

export const MapsScreenLazy = (): JSX.Element => {
    return (
        <Suspense fallback={<MapScreenLazyLodingUI />}>
            <MapsScreen />
        </Suspense>
    );
};

const MapScreenLazyLodingUI = () => {
    const otherPlatforms = getQueryParamByName('s');
    const shouldDisableOnOtherPlatforms = !!otherPlatforms;
    return (
        <section className='map__landing_page'>
            <div className='map__content-wrapper'>
                <canvas className='map__canvas-container'></canvas>
                { !shouldDisableOnOtherPlatforms && <div className='map__control-container'>
                    <div className='map__layers-control-wrapper'>
                        <div className='map__layers-outer-controls'>
                            <div className='map__layer-picker-container'>
                                <h3 className='map__layer-selector-header'>Weather Overlay</h3>
                            </div>
                            <div className='map__zoom-picker-container'>
                                <div className='map__zoom-picker-markup'></div>
                            </div>
                        </div>
                        <div className='map__layer-inner-container'></div>
                    </div>
                </div>}
                { !shouldDisableOnOtherPlatforms && <div className='map__ad-wrapper'>
                    <div className='map__ad-container'></div>
                </div>}
            </div>
        </section>
    );
};